export default {
  storageTokenKeyName: '@MagoAccount_accessToken',
};
